import { apiGet } from './client';

// ── Dashboard counts ──────────────────────────────────────────────────────────

export interface DashboardCategory {
  categoryId: string;
  categoryName: string;
  count: number;
  categoryColourPreset?: string | null;
  categoryColourHex?: string | null;
}

export interface DashboardSubset {
  subsetId: string;
  subsetName: string;
  isMutuallyExclusive: boolean;
  totalConversations: number;
  categories: DashboardCategory[];
}

export interface DashboardCountsResponse {
  subsets: DashboardSubset[];
  totalInboxCount: number;
  exactConversationCount: boolean;
}

export async function getDashboardCounts(): Promise<DashboardCountsResponse> {
  return apiGet<DashboardCountsResponse>('/api/dashboard/counts?exactConversationCount=true');
}

// ── Dashboard SLA ─────────────────────────────────────────────────────────────

export interface SlaWindowStats {
  open: number;
  closedOnTime: number;
  breached: number;
  periodStart: string;
  periodEnd: string;
}

export interface DashboardSlaResponse {
  '7d': SlaWindowStats;
  '30d': SlaWindowStats;
}

export async function getDashboardSla(): Promise<DashboardSlaResponse> {
  return apiGet<DashboardSlaResponse>('/api/dashboard/sla');
}

// ── Latest digest ─────────────────────────────────────────────────────────────

export interface LatestDigestResponse {
  html: string | null;
  generatedAt: string | null;
}

export async function getLatestDigest(): Promise<LatestDigestResponse> {
  return apiGet<LatestDigestResponse>('/api/digest/latest');
}
